export interface AwsCredentials {
    accessKeyId: string
    secretAccessKey: string
    sessionToken?: string
    expiration?: string // ISO string for Redux serialization
}

export interface MsalCredentials {
    idToken: string
    accessToken: string
    confidenceLevel: number
    expiration: string // ISO string for Redux serialization
}

export interface QrToken {
    idToken: string
}

/**
 * The MSAL access token from the Redux `msalCredentials`, or throw.
 *
 * `auth.msalCredentials` is `null` when signed out, but the plan screens read
 * it as always set. Reading `.accessToken` on `null` used to throw a TypeError
 * at the read site; this throws at the same point with a clear message, so the
 * caller's control flow is unchanged.
 */
export const requireMsalAccessToken = (
    credentials: MsalCredentials | null | undefined
): string => {
    if (!credentials) {
        throw new Error('No MSAL credentials (auth.msalCredentials is not set)')
    }
    return credentials.accessToken
}

export interface QrCredentials {
    accessToken: string
    confidenceLevel: number
}
